export default "__VITE_ASSET__rf3nzSiv__"